import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ScenariosEffects } from './scenarios.effects';
import { ScenariosFacade } from './scenarios.facade';
import { ScenariosService } from './scenarios.service';
import { scenariosReducer } from './scenarios.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('scenarios', scenariosReducer),
    EffectsModule.forFeature([
      ScenariosEffects,
    ]),
  ],
  providers: [
    ScenariosService,
    ScenariosFacade,
  ],
})
export class ScenariosModule {}
